<template>
    <Grid/>
</template>

<script>
    import Grid from './../components/Program/POA/components/Budget/components/Requests/Grid'

    export default {
        components: {
            Grid,
        }
    }
</script>